import { z } from 'zod';

// Accumulator price only for double, treble, xF bets
export const betTypesNotForAccumulatorPrice = [
    'SGL',
    'RAB',
    'BB',
    'TTW',
    'TTP',
    'FC',
    'RFC',
    'SSA',
    'TTE',
    'TTRE',
    'TRX',
    'PAT',
    'RR',
    'TC',
    'CFC',
    'CTC',
    'TTT',
    'TTCE',
    'TTCT',
    'YNK',
    'YAN',
    'L15',
    'FLG',
    'TTQ',
    'CAN',
    'L31',
    'SFLG',
    'HNZ',
    'L63',
    'TTPP',
    'TTJP',
    'TTS6',
    'SHNZ',
    'GOL',
    'BB',
];

const RowZod = z.object({
    type: z.string().nullish(),
});

type RowType = z.TypeOf<typeof RowZod>;

const PriceZod = z
    .object({
        d: z.number(),
        f: z.string(),
    })
    .nullable();

const BetDataZod = z.array(
    z.object({
        legs: z.array(
            z.object({
                price: PriceZod,
            })
        ),
    })
);

type BetDataType = z.TypeOf<typeof BetDataZod>;

export const getAccumulatorPrice = (row: RowType, betData: BetDataType): string => {
    // RowZod.parse(row);
    // BetDataZod.parse(betData);

    try {
        if (row.type === null || row.type === undefined) {
            return '';
        }

        if (betTypesNotForAccumulatorPrice.includes(row.type)) {
            return '';
        }

        if (betData.length === 1) {
            return '-';
        }

        return betData
            .reduce((acc, curr) => {
                const legs = curr.legs;
                const value = legs.reduce((acc, curr): number => {
                    if (curr.price === null) {
                        return acc;
                    }

                    return acc * curr.price.d;
                }, 1);

                return acc * value;
            }, 1)
            .toFixed(2);
    } catch (err) {
        console.error(err);
        console.info(
            JSON.stringify({
                row,
                betData,
            })
        );

        return '';
    }
};
